<div class="container" *ngIf="showContent" @fadeAnimation>
  <app-assistant-popup-header class="header"></app-assistant-popup-header>
  <app-assistant-popup-steps class="steps" *ngIf="data.steps" [steps]="data.steps"></app-assistant-popup-steps>
  <app-assistant-popup-content class="content" [content]="data.content"></app-assistant-popup-content>
  <app-assistant-popup-action-buttons
    class="action-buttons"
    *ngIf="data.actions"
    [actions]="data.actions"
  ></app-assistant-popup-action-buttons>
</div>
